/**
 * Created by mauget on 3/5/16.
 */

// PageSyncService.js
import $                from 'jquery';
import PageModel        from 'PageModel';
import listService      from 'ListService.js';
import constants        from 'Constants.js';
import eventBus         from 'EventBus.js';
import pageCollection   from 'PageCollection';
import resizeController from 'ResizeController.js';
import util             from 'util/Util.js';

import MobileColumnsView from '../views/mobile/MobileDesignerColumnView';


//=====================================================================================================
// This singleton manages a list of editor page objects. Intended as a central manager that
// can synchronize a provided Backbone Collection object with the ListService page list.
//
// - Lou Mauget March 5, 2016
//=====================================================================================================
class PageSyncService {
    mobileColumnsView;

    //========================================================================================
    // Sync the given Backbone collection from the page list and its control children
    // (When Listservice collections refactored to BB collections, this could be irrelelvant)
    //========================================================================================
    sync( bbColl ) {

        const models = [];
        const plist = listService.pageList;

        // Sync bbColl to pageList, merging changed entries, or adding new entries.
        plist.map( (pObj, pageId) => {

            const attrs = {};
            attrs.id = pageId;
            attrs.pageNumber = pObj.model.get('pageNumber');
            attrs.pageTitle =  pObj.model.get('pageTitle');
            attrs.name =  pObj.model.get('name');
            attrs.seq = pObj.model.get('seq');

            attrs.behaviors = [ ]; //[ {name: 'On Page Open', link: ''} ];

            attrs.objects   = [ ];
            listService.getPageControls( pageId ).map( control => {
                const obj = {};
                obj.name = control.model.get('name');
                obj.link = '';
                obj.id = control.model.get('id');
                obj.groupId = control._groupId ? control._groupId : '';
                attrs.objects.push( obj );
            });

            listService.getBehaviorInstanceByPage( pageId ).map( instance => {
                const obj = {};
                obj.name = instance.get('text');
                obj.link = '';
                obj.id = instance.get('id');
                attrs.behaviors.push( obj );

            });

            attrs.behaviorCount = attrs.behaviors.length;
            attrs.objectCount   = attrs.objects.length;

            const pgModel = new PageModel( attrs );
            pgModel.attributes.objects = attrs.objects;
            pgModel.attributes.behaviors = attrs.behaviors;
            pgModel.attributes.behaviorCount = attrs.behaviorCount;
            pgModel.attributes.objectCount = attrs.objectCount;

            models.push( pgModel );

        } );

        // BB collection.set() does a magic sane merge, firing appropriate events
        bbColl.set( models, {silent:true} );

        // sort on timestamp
        //bbColl.sort();


    }

    //========================================================================================
    // Removes outgoing page's controls from the DOM only. (Not from the objList)
    //========================================================================================
    clearCurrentPageView( pageId = listService.currentPageId) {
        if (pageId) {
            listService.objectList
                .filter(view => view.pageId === pageId)
                .map( view => {
                    $(`${constants.ID_SEL}${view.id}`).remove();
                });
            // PF-1982
            listService.clearSelected();
        }
    }

    //=========================================================x===============================
    // Inserts incoming page's controls into the DOM.
    // Sets the layout type on all the controls available in the page.
    //========================================================================================
    renderCurrentPageView( pageId = listService.currentPageId, isFirstLoad = false ) {
        const myPage = listService.getPage(pageId);
        if (myPage && myPage.model) {

            const myPage = listService.getPage(listService.currentPageId);
            listService.unsetPageOriginalItems(myPage.model.get('id'));

            eventBus.trigger('pageRedraw', myPage.model.get('backgroundColor'),
                myPage.model.get('backgroundImageAssetId'),
                myPage.model.get('backgroundImageStyle'));

            myPage.$el.hide();

            let controls = listService.getPageControls(pageId);
            controls.forEach(view => {
                this.setCurrentPageLayoutOnControlView(view);
                //  If view belongs to a group, do not render it here.
                //  It will be rendering on GroupControlView, on afterRenderingGroups function.
                if (!view._groupId) {
                    view.render({skipEventRegistration: !isFirstLoad});
                }
            });

            // once for entire page`
            resizeController.listenForResizeRequest();

            myPage.$el.show();

            // var t1 = performance.now();
            // console.log(t1 - t0, 'ms to render page');
        }
    }

    //========================================================================================
    // Inserts incoming page's sections and controls into the DOM.
    // Sets the layout type on all the sections and controls available in the page.
    //========================================================================================
    renderMobileCurrentPageView( pageId = listService.currentPageId ) {
        const myPage = listService.getPage(pageId);
        if (myPage && myPage.model) {

            eventBus.trigger('pageRedraw', myPage.model.get('backgroundColor'),
                myPage.model.get('backgroundImageAssetId'),
                myPage.model.get('backgroundImageStyle'));

            myPage.$el.hide();

            if (this.mobileColumnsView) {
                this.mobileColumnsView.remove();
            }

            this.mobileColumnsView = new MobileColumnsView({model: myPage.model});

            $('#aPage').append(this.mobileColumnsView.render().$el);
            //PF-5451 - Possible memory leak: Commented these lines because they were causing multiple renders, testing required before deleting them
                //this.mobileColumnsView.updateColumnView();
                //this.mobileColumnsView.sectionsLayoutRender(this.mobileColumnsView.getCurrentLayout());
            this.mobileColumnsView.afterRenderMobileColumns();

            // once for entire page`
            resizeController.listenForResizeRequest();

            myPage.$el.show();

        }
    }

    renderCurrentPageLayout() {
        let myPage = listService.getPage(listService.currentPageId);
        if (myPage && myPage.model) {
            eventBus.trigger('pageRedraw', myPage.model.get('backgroundColor'),
                myPage.model.get('backgroundImageAssetId'), myPage.model.get('backgroundImageStyle'));


        }
    }
    
    //========================================================================================
    // Inserts the current layout being worked in the model of a given control
    //========================================================================================
    setCurrentPageLayoutOnControlView(controlView){
        const currentLayout=listService.currentForm.model.attributes.currentLayout;
        controlView.model.attributes.currentLayout=currentLayout;
    }

    //========================================================================================
    // Remove current controls from the DOM, set current page to pageId, and then insert its
    // controls into the DOM. I.E. Display the page.
    //========================================================================================
    displayPage(pageId, isFirstLoad = false) {

        if ((constants.KIND_MOBILE).includes( listService.mainKind)) {
            this.clearCurrentPageView();
            listService.currentPageId = pageId;
            this.renderMobileCurrentPageView();
        }
        else if ((constants.KIND_REPORT + constants.KIND_LAYOUT).includes( listService.mainKind ) ) {
            this.clearCurrentPageView();
            listService.currentPageId = pageId;
            this.renderCurrentPageView(undefined, isFirstLoad);
            setTimeout(()=>{
                util.updateHelpDocumentationLink(listService.mainKind);
            },50);

        }

    }

    //========================================================================================
    // De-selects existing selected thumbnail, then selects thumbnail corresponding to given pageId.
    // force = will force the selection and re-render of page/items even if it on current page.
    //========================================================================================
    selectThumbNail(force = false,  pageId = listService.currentPageId ) {
        // finds thumbnail for currentPageId, then selects it.
        $( `[data-page='${pageId}']`).trigger('click', force);

    }

    // These Add/Remove methods allow us to change the collections without having to call a full Page Sync that would process all pages.
    addItemToPageCollection(item, page, collectionType) {
        // object or behaviors
        switch (collectionType) {
            case 'object':
                page.model.get('objects').push(item);
                page.model.attributes.objectCount++;
                break;
            case 'behaviors':
                page.model.get('behaviors').push(item);
                page.model.attributes.behaviorCount++;
                break;
        }
    }

    removeItemFromPageCollection(id, page, collectionType) {
        if (page) {
            switch (collectionType) {
                case 'object':
                    for (let i = page.model.get('objects').length - 1; i >= 0; i--) {
                        if (page.model.get('objects')[i].id === id) {
                            page.model.get('objects').splice(i, 1);
                        }
                    }

                    page.model.attributes.objectCount--;
                    break;
                case 'behaviors':
                    for (let i = page.model.get('behaviors').length - 1; i >= 0; i--) {
                        if (page.model.get('behaviors')[i].id === id) {
                            page.model.get('behaviors').splice(i, 1);
                        }
                    }
                    page.model.attributes.behaviorCount--;
                    break;
            }
        }
    }

    removePageFromPageCollection(pageId) {
        pageCollection.remove(pageCollection.where({id: pageId }));
    }

    addPageFromPageCollection(pageObj) {
        const attrs = {};
        attrs.id = pageObj.model.get('id');
        attrs.pageNumber = pageObj.model.get('pageNumber');
        attrs.pageTitle =  pageObj.model.get('pageTitle');
        attrs.name =  pageObj.model.get('name');
        attrs.seq = pageObj.model.get('seq');
        attrs.gridHeight = pageObj.model.get('gridHeight');
        attrs.gridWidth = pageObj.model.get('gridWidth'); 
        attrs.shadow = pageObj.model.get('shadow');   
 
        const pgModel = new PageModel( attrs );
        
        let index = pageCollection.length;
        if(pageObj.currentIndex || pageObj.currentIndex === 0){
            index = pageObj.currentIndex;
        }

        pgModel.currentIndex = index;
        pageCollection.add(pgModel, {at: index});
    }

    getPageCollection(){
        return pageCollection;
    }

}


const pageSyncService = new PageSyncService();
export default pageSyncService;
